import { BaseService } from '../../base';
import type {
  ListQuoteActivitiesParams,
  ListQuoteActivitiesResponse,
} from './types';

export type {
  ListQuoteActivitiesParams,
  ListQuoteActivitiesResponse,
  QuoteActivity,
  QuoteActivityChange,
  QuoteActivityChangeOp,
  QuoteActivityValueKind,
} from './types';

/**
 * Histórico de atividades da cotação (trilha de auditoria).
 *
 * O endpoint é comum a todos os produtos e restrito a perfis da seguradora —
 * corretor recebe 403.
 */
export class QuoteActivitiesService extends BaseService {
  private readonly customBaseUrl: string;

  constructor() {
    super();
    this.customBaseUrl = import.meta.env.VITE_API_URL;
  }

  async listActivities(
    policyId: string,
    params: ListQuoteActivitiesParams = {}
  ): Promise<{
    success: boolean;
    data?: ListQuoteActivitiesResponse;
    error?: string;
  }> {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', String(params.limit));
    if (params.cursor) queryParams.append('cursor', params.cursor);

    const query = queryParams.toString();
    const response = await this.get(
      `/portal/v1/quotes/${encodeURIComponent(policyId)}/activities${
        query ? `?${query}` : ''
      }`,
      {},
      this.customBaseUrl
    );

    return this.handleJsonResponse<ListQuoteActivitiesResponse>(response);
  }
}

export const quoteActivitiesService = new QuoteActivitiesService();
